import { NgModule } from '@angular/core';
import { StoreModule } from '@ngrx/store';
import { backend } from '@shared/datastore/core';
import { userRecentProjectsAndContestsBackend } from './user-recent-projects-and-contests.backend';
// import { DatastoreBackendModule } from '@shared/datastore/core';
import { userRecentProjectsAndContestsReducer } from './user-recent-projects-and-contests.reducer';

// FIXME: remove that
backend.userRecentProjectsAndContests = userRecentProjectsAndContestsBackend;

@NgModule({
  imports: [
    StoreModule.forFeature(
      'userRecentProjectsAndContests',
      userRecentProjectsAndContestsReducer,
    ),
    /* DatastoreBackendModule.forFeature(
      'userRecentProjectsAndContests',
      userRecentProjectsAndContestsBackend,
    ),*/
  ],
})
export class DatastoreUserRecentProjectsAndContestsModule {}



// WEBPACK FOOTER //
// ./src/app/@shared/datastore/user-recent-projects-and-contests/user-recent-projects-and-contests.module.ts